/* ============================================
   Brandon T. Jackson Theme — Main JavaScript
   ============================================ */

(function() {
  'use strict';

  // ---- Intersection Observer for scroll animations ----
  var observerOptions = {
    threshold: 0.12,
    rootMargin: '0px 0px -40px 0px'
  };
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  function initScrollAnimations() {
    var elements = document.querySelectorAll('.event-card, .tour-item, .product-card, .tour-stat');
    elements.forEach(function(el, i) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity 0.5s ease ' + (i * 0.07) + 's, transform 0.5s ease ' + (i * 0.07) + 's';
      observer.observe(el);
    });
    document.addEventListener('is-visible-added', function() {});
  }

  // Custom observer callback to add styles
  var styleObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
        styleObserver.unobserve(entry.target);
      }
    });
  }, observerOptions);

  function initAnimations() {
    var elements = document.querySelectorAll('.event-card, .tour-item, .product-card, .tour-stat, .footer-col');
    elements.forEach(function(el, i) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(22px)';
      el.style.transition = 'opacity 0.55s ease ' + (i * 0.06) + 's, transform 0.55s ease ' + (i * 0.06) + 's';
      styleObserver.observe(el);
    });
  }

  // ---- Sticky header scroll shadow ----
  function initStickyHeader() {
    var header = document.querySelector('.site-header');
    if (!header) return;
    var scrolled = false;
    window.addEventListener('scroll', function() {
      if (window.scrollY > 50 && !scrolled) {
        header.style.boxShadow = '0 4px 30px rgba(0,0,0,0.6)';
        scrolled = true;
      } else if (window.scrollY <= 50 && scrolled) {
        header.style.boxShadow = 'none';
        scrolled = false;
      }
    }, { passive: true });
  }

  // ---- Toast Notifications ----
  function showToast(message, icon) {
    var existing = document.querySelector('.toast-notification');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.className = 'toast-notification';
    toast.innerHTML = (icon ? '<span class="toast-icon">' + icon + '</span>' : '') + '<span>' + message + '</span>';
    document.body.appendChild(toast);
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        toast.classList.add('show');
      });
    });
    setTimeout(function() {
      toast.classList.remove('show');
      setTimeout(function() { toast.remove(); }, 400);
    }, 3500);
  }
  window.showToast = showToast;

  // ---- Smooth scroll for anchor links ----
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function(link) {
      link.addEventListener('click', function(e) {
        var target = document.querySelector(this.getAttribute('href'));
        if (target) {
          e.preventDefault();
          var headerHeight = document.querySelector('.site-header') ? document.querySelector('.site-header').offsetHeight : 0;
          var offset = target.getBoundingClientRect().top + window.scrollY - headerHeight - 20;
          window.scrollTo({ top: offset, behavior: 'smooth' });
        }
      });
    });
  }

  // ---- Mobile menu close on outside click ----
  function initMobileMenu() {
    document.addEventListener('click', function(e) {
      var nav = document.getElementById('site-nav');
      var hamburger = document.getElementById('hamburger');
      if (nav && nav.classList.contains('open')) {
        if (!nav.contains(e.target) && !hamburger.contains(e.target)) {
          nav.classList.remove('open');
        }
      }
    });
  }

  // ---- Image lazy loading fallback ----
  function initLazyImages() {
    if ('loading' in HTMLImageElement.prototype) return;
    var lazyImages = document.querySelectorAll('img[loading="lazy"]');
    var imageObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var img = entry.target;
          if (img.dataset.src) { img.src = img.dataset.src; }
          imageObserver.unobserve(img);
        }
      });
    });
    lazyImages.forEach(function(img) { imageObserver.observe(img); });
  }

  // ---- Active nav link highlighting based on current page ----
  function initActiveNav() {
    var currentPath = window.location.pathname;
    document.querySelectorAll('.site-nav a').forEach(function(link) {
      if (link.getAttribute('href') === currentPath) {
        link.classList.add('active');
      }
    });
  }

  // ---- Keyboard trap for cart drawer ----
  function trapFocus(element) {
    var focusable = element.querySelectorAll('a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])');
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    element.addEventListener('keydown', function(e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }
  window.trapFocus = trapFocus;

  // ---- Init all on DOM ready ----
  document.addEventListener('DOMContentLoaded', function() {
    initAnimations();
    initStickyHeader();
    initSmoothScroll();
    initMobileMenu();
    initLazyImages();
    initActiveNav();

    // Setup cart drawer trap focus
    var cartDrawer = document.getElementById('cartDrawer');
    if (cartDrawer) {
      cartDrawer.addEventListener('transitionend', function() {
        if (cartDrawer.classList.contains('active')) {
          var closeBtn = cartDrawer.querySelector('.cart-close-btn');
          if (closeBtn) closeBtn.focus();
          trapFocus(cartDrawer);
        }
      });
    }

    // Add skip link
    var skipLink = document.createElement('a');
    skipLink.href = '#main-content';
    skipLink.className = 'skip-link';
    skipLink.textContent = 'Skip to main content';
    document.body.insertBefore(skipLink, document.body.firstChild);
  });

})();
